import { CollectionBannerElementDataType } from '@/components/sections/builder/elements/body/collection-banner/type';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Checkbox } from '@/components/ui/checkbox';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingCollectionBanner({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as CollectionBannerElementDataType;

  return (
    <div>
      <div className='my-4 flex gap-x-1'>
        <Checkbox
          id='isShowDescription'
          className='mx-2'
          checked={data.isShowDescription}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              isShowDescription: !!checked,
            });
          }}
        />
        <label htmlFor='isShowDescription'>Show collection description</label>
      </div>
      <div className='my-4 flex gap-x-1'>
        <Checkbox
          id='isShowImage'
          className='mx-2'
          checked={data.isShowImage}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              isShowImage: !!checked,
            });
          }}
        />
        <label htmlFor='isShowImage'>Show collection image</label>
      </div>
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={data.colorScheme}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorScheme: theme,
          });
        }}
      />
    </div>
  );
}
